<template>
  <v-container
    fluid
    class="firma-container-default"
  >
    <v-row>
      <v-col>
        <SearchInput
          v-model="debounce"
        ></SearchInput>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <SelectCategory
          :categories="categories"
          :index="query.index"
          v-model="query.category"
          :updateQuery="updateQuery"
          outlined
          dense
          color="primary"
        ></SelectCategory>
      </v-col>
      <v-col>
        <SelectTime
          dense
          outlined
          color="primary"
          v-model="query.time"
          :updateQuery="updateQuery"
        ></SelectTime>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card elevation="0" class="firma-card">
          <v-list v-if="isLoading">
            <v-skeleton-loader
              type="list-item-two-line"
              v-for="n in 30"
              :key="`loader-${n}`"
            ></v-skeleton-loader>
          </v-list>
          <v-list v-else-if="isEmpty">
            <v-list-item>
              <v-list-item-content class="firma-list-item">
                <v-list-item-title class="text-center">{{ $t('noData.title') }}</v-list-item-title>
                <v-list-item-subtitle class="text-center">{{ $t('noData.subtitle') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-else>
            <v-list-item @click.stop="onClickHit(post.url)" v-for="(post, i) in items" :key="i">
              <v-list-item-content>
                <v-list-item-title v-html="post.title"></v-list-item-title>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="caption flex-none"
                      >{{ parseDate({ date:post.date, operation: 'fromNow' }) }}</span>
                    </template>
                    <span>{{ parseDate({ date:post.date, operation: 'format' }) }}</span>
                  </v-tooltip>
                <v-list-item-subtitle class="white-space-normal mb-2" v-html="post.excerpt"></v-list-item-subtitle>
                <v-chip-group class="firma-category-chip">
                  <v-chip class="ma-0" @click.stop="updateQuery({ category: post.category })">{{ post.category }}</v-chip>
                </v-chip-group>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <Pagination
            v-if="nbHits > 0"
            v-model="query.page"
            :length="nbPages"
            @input="(page) => updateQuery({ page })"
          ></Pagination>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment';
import SearchInput from '@/components/shared/search/input/Input';
import SelectCategory from '@/components/shared/search/select/Category';
import SelectTime from '@/components/shared/search/select/Time';
import Pagination from '@/components/shared/pagination/Pagination';

export default {
  components: {
    SearchInput,
    SelectCategory,
    SelectTime,
    Pagination,
  },
  props: {
    categories: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    isEmpty: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    updateQuery: {
      type: Function,
      required: true,
    },
    nbPages: {
      type: Number,
      required: true,
    },
    nbHits: {
      type: Number,
      required: true,
    },
  },
  data() {
    const {
      q,
      page,
      category,
      time,
      index,
    } = this.$route.query;
    return {
      query: {
        q: q || '',
        page: page || 1,
        category: category || this.$t('all'),
        time: time || { text: 'all', value: null},
        index: index || 'dev_cms_german',
      },
      timeout: null,
    }
  },
  computed: {
    debounce: {
      get() {
        return this.query.q
      },
      set(q) {
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.updateQuery({ q });
        }, 1000)
      }
    },
  },
  methods: {
    onClickHit(url) {
      window.open(url, '_blank');
    },

    parseDate({ date, operation }) {
      const { lang } = this.$route.query;
      const time = moment(date).locale(lang || 'de')
      const hash = {
        format: (format) => {
          return time.format(format || 'D.MMMM YYYY')
        },
        fromNow: () => {
          return time.fromNow();
        }
      };
      return hash[operation]();
    },
  },
}
</script>